"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("primereact/button");
const react_router_dom_1 = require("react-router-dom");
const titles_1 = require("../../../routes/titles");
const react_i18next_1 = require("react-i18next");
const navBarMobile_module_scss_1 = __importDefault(require("./navBarMobile.module.scss"));
const routeTitles = new Map([
    ['/', titles_1.HOME_TITLE],
    ['/machines/list', titles_1.MACHINE_LIST_TITLE],
    ['/reFills/list', titles_1.REFILLS_LIST_TITLE],
    ['/products/list', titles_1.PRODUCTS_LIST_TITLE],
    ['/orders/list', titles_1.ORDERS_LIST_TITLE],
    ['/mobile/profile', titles_1.MOBILE_PROFILE_TITLE],
    ['/products/create', titles_1.PRODUCTS_CREATE_TITLE],
    ['/products/:id', titles_1.PRODUCTS_EDIT_TITLE],
    ['/billing/:id', titles_1.CLUB_INVOICE_DETAIL_TITLE],
    ['/billing/list', titles_1.CLUB_INVOICE_LIST_TITLE],
    ['/settlement/list', titles_1.SETTLEMENT_LIST_TITLE],
]);
const NavBarMobile = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const isInvoiceRoute = location.pathname.startsWith('/invoices');
    const getTitleFromRoute = (pathname) => {
        if (routeTitles.has(pathname)) {
            return routeTitles.get(pathname);
        }
        if (/^\/machines\/[^/]+\/configuration$/.test(pathname)) {
            return titles_1.MACHINE_CONFIG_TITLE;
        }
        if (/^\/machines\/\d+$/.test(pathname)) {
            return location.state?.name || 'Machine Detail';
        }
        if (/^\/products\/[a-zA-Z0-9]+$/.test(pathname)) {
            return titles_1.PRODUCTS_EDIT_TITLE || 'Product Detail';
        }
        if (/^\/refills\/[a-zA-Z0-9]+$/.test(pathname)) {
            return titles_1.REFILLS_DETAIL_TITLE || 'Product Detail';
        }
        if (/^\/orders\/[a-fA-F0-9-]+$/.test(pathname)) {
            return titles_1.ORDERS_DETAIL_TITLE || 'Order Detail';
        }
        if (/^\/billing\/[a-fA-F0-9-]+$/.test(pathname)) {
            return titles_1.CLUB_INVOICE_DETAIL_TITLE || 'Club PdfInvoice Detail';
        }
        if (/^\/settlement\/[a-fA-F0-9-]+$/.test(pathname)) {
            return titles_1.SETTLEMENT_DETAIL_TITLE || 'Settlement Detail';
        }
        return 'Home';
    };
    const handleGoBack = () => {
        navigate(-1);
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: isInvoiceRoute ? navBarMobile_module_scss_1.default.containerInvoice : navBarMobile_module_scss_1.default.container, children: !isInvoiceRoute && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-arrow-left", className: `p-button-text ${navBarMobile_module_scss_1.default.navigateButton}`, onClick: handleGoBack }), (0, jsx_runtime_1.jsx)("div", { className: navBarMobile_module_scss_1.default['title-wrapper'], children: (0, jsx_runtime_1.jsx)("h1", { className: navBarMobile_module_scss_1.default.title, children: t(getTitleFromRoute(location.pathname)) }) })] })) }));
};
exports.NavBarMobile = NavBarMobile;
